import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, Observable, switchMap, take } from 'rxjs';

@Injectable()
export class UsernameInterceptor implements HttpInterceptor {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return this.oidcSecurityService.userData$.pipe(
      take(1),
      map((data) => (data.userData?.sub ?? '') as string),
      map((subject) => {
        if (subject.length > 0) {
          return req.clone({
            headers: req.headers.set('Username', subject),
          });
        } else {
          return req;
        }
      }),
      switchMap((request) => next.handle(request))
    );
  }
}
